import CardHead from "../cardHead";
import PricePanel from "../pricePanel";
import eth from "@assets/eth.svg";
import atom from "@assets/atom.svg";
import swth from "@assets/swth.svg";
import dot from "@assets/dot.svg";
import bnb from "@assets/bnb.svg";
import matic from "@assets/matic.svg";
import ksm from "@assets/ksm.svg";
import Item from "./item";
import sol from "@assets/sol.svg";
import iris from "@assets/iris.svg";
import huahua from "@assets/huahua.svg";
import sei from "@assets/sei.svg";
import "./index.scss";
import { useEffect, useState } from "react";
import { getRatelist } from "@/api";
import LoadingOutlined from "../loadingOutlined";
export default function Index() {
  const [data, setData] = useState<any[]>([]);
  const [fis, setFis] = useState<any>();

  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    getRatelist()
      .then((res) => {
        if (res.data.status == "80000") {
          const obj = res.data.data.list.find((item: any) => {
            return item.symbol == "FIS";
          });
          setFis(obj);
          const list = res.data.data.list.map((item: any) => {
            if (item.symbol == "ETH") {
              item.icon = eth;
            } else if (item.symbol == "DOT") {
              item.icon = dot;
            } else if (item.symbol == "KSM") {
              item.icon = ksm;
            } else if (item.symbol == "ATOM") {
              item.icon = atom;
            } else if (item.symbol == "MATIC") {
              item.icon = matic;
            } else if (item.symbol == "BNB") {
              item.icon = bnb;
            } else if (item.symbol == "SOL") {
              item.icon = sol;
            } else if (item.symbol == "IRIS") {
              item.icon = iris;
            } else if (item.symbol == "HUAHUA") {
              item.icon = huahua;
            } else if (item.symbol == "SWTH") {
              item.icon = swth;
            } else if (item.symbol == "SEI") {
              item.icon = sei;
            }
            return item;
          });
          setData(list);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="rTokenRateContainer">
      <CardHead
        title="rToken Rate"
        tips={`The Number of tokens needed to be exchanged for 1 rToken, the exchange rate of rToken will be updated every 8 hours.`}
      />
      <LoadingOutlined spin={loading}>
        <PricePanel
          color="blue"
          text={`FIS : rFIS = ${fis ? Number(fis.rate).toFixed(4) : "--"} : 1`}
        />
        {data.map((item: any) => {
          if (item.symbol == "FIS") {
            return undefined;
          }
          return (
            <Item
              key={item.symbol}
              title={`${item.symbol} : ${item.rsymbol}`}
              icon={item.icon}
              value={` ${Number(item.rate).toFixed(4) || "--"} : 1`}
            />
          );
        })}
      </LoadingOutlined>
    </div>
  );
}
